export const HomePage = () => {
    return <section className="home-page full">
    </section>;
};